/**
 * Erkennt, wenn der Server inzwischen eine neuere Web-Version ausliefert
 * (z. B. nach `docker compose up --build`), während dieser Tab noch den alten Code ausführt.
 */
let ownBuild: string | null = null;
let outdated = false;

/** Wird im Einstiegsmodul mit dessen `import.meta.url` aufgerufen (Dateiname enthält den Build-Hash). */
export function setOwnBuild(entryUrl: string): void {
  const name = new URL(entryUrl).pathname.split('/').pop() ?? '';
  // Nur gebaute Bundles (index-<hash>.js); in der Entwicklung keine Prüfung
  ownBuild = /^index-[\w-]+\.js$/.test(name) ? name : null;
}

/** Prüft den Build-Header einer Server-Antwort. */
export function checkServerBuild(res: Response): void {
  const server = res.headers.get('x-kartothek-build');
  if (!ownBuild || !server || server === ownBuild || outdated) return;
  outdated = true;
  window.dispatchEvent(new Event('kt:outdated'));
}

export function isOutdated(): boolean {
  return outdated;
}
